import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';

function NRValueTooltipIcon({ value, tooltip, icon, tooltipComponent, style, placement = 'top' }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', ...style }}>
      <Box component={'span'}>{value}</Box>
      {(!!tooltip || !!tooltipComponent) && (
        <Tooltip title={tooltipComponent || tooltip} placement={placement}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box>
        </Tooltip>
      )}
      {!tooltip && !!icon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{icon}</Box>}
    </Box>
  );
}

export default NRValueTooltipIcon;
